import React, { useState } from 'react';
import classnames from 'classnames';
import X, { Color } from '@shared/Icons/X';
import FindViewMapMobile from './FindViewMapMobile';
import BrowseLayout from '../BrowseLayout';
import FilterBar from '../../components/FilterBar';
import { filterBarContainer } from '../../styles.module.css';

import {
  base,
  baseMobile,
  translateDown,
  closeButton,
  background,
  parallaxLayer1,
  parallaxLayer2,
  filterBarContainerFixed,
} from './styles.module.css';

const FindMobileLayout = ({ categoryData, ...props }) => {
  const [showEventList, updateShowEventList] = useState(true);

  const toggleShowEventList = () => {
    updateShowEventList(!showEventList);
  };

  const backgroundClasses = classnames(background, {
    [translateDown]: !showEventList,
  });

  return (
    <>
      <div
        className={showEventList ? filterBarContainer : filterBarContainerFixed}
      >
        <FilterBar />
      </div>
      <div className={showEventList ? baseMobile : base}>
        <div className={backgroundClasses}>
          <FindViewMapMobile
            categoryData={categoryData}
            hideEventList={showEventList}
            {...props}
          />
          {!showEventList && (
            <X
              color={Color.GREY}
              className={closeButton}
              onClick={toggleShowEventList}
              onKeyPress={toggleShowEventList}
            />
          )}
        </div>
        {showEventList && (
          <>
            <div
              className={parallaxLayer1}
              onClick={toggleShowEventList}
              onPointerDown={toggleShowEventList}
              onKeyPress={toggleShowEventList}
            />
            <div className={parallaxLayer2}>
              <BrowseLayout
                categoryData={categoryData}
                {...props}
                isGroupingsHidden
                isHeaderHidden
              />
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default FindMobileLayout;
